import { handle } from 'redux-pack';
import { assoc } from 'ramda';

import { get } from 'lib/communication';
import createReducer from 'lib/createReducer';

/* Action types */

const LOAD = 'myms/settings/LOAD';

export const actionTypes = { LOAD };

/* Action creator(s) */

const loadSettings = () => ({
  type: LOAD,
  promise: get('/appsettings/v1'),
});

export const actions = { loadSettings };

/* Handlers and the reducer */

const initialState = {};

const handleLoadSettings = (s, a) =>
  handle(s, a, {
    start: assoc('isLoading', true),
    finish: assoc('isLoading', false),
    failure: assoc('error', a.payload),
    success: preState => ({
      ...preState,
      ...a.payload,
    }),
  });

export default createReducer(initialState, {
  [LOAD]: handleLoadSettings,
});
